// extracted by mini-css-extract-plugin
export default {"cta":"H1xQaHumwdoQJUrx2WOw","title-cta":"nnVVnto7uaSL86FdX2gT","titleCta":"nnVVnto7uaSL86FdX2gT","button-cta":"IVrwhyf7QP8XxfX34WKc","buttonCta":"IVrwhyf7QP8XxfX34WKc"};